// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Bo-z","badgeLink":"Co-z","category":"Do-z"};